(function () {
  var btn = document.getElementById("NewsletterPopupButton--header-drawer");
  var emailInput = document.getElementById("NewsletterForm--header-drawer");
  var emailValidateMsg = document.getElementById(
    "NewsletterEmailValidateMsg"
  ).value;
  if (!btn || !emailInput) return;
  function showError(msg) {
    var box = document.getElementById("NewsletterErrorBox--header-drawer");
    if (box) {
      box.innerHTML =
        '<div class="newsletter-error-box"><span class="newsletter-error-message">' +
        msg +
        "</span></div>";
    }
    emailInput.classList.add("has-error");
    btn.classList.add("has-error");
  }
  function clearError() {
    var box = document.getElementById("NewsletterErrorBox--header-drawer");
    if (box) box.innerHTML = "";
    emailInput.classList.remove("has-error");
    btn.classList.remove("has-error");
  }
  btn.addEventListener("click", function (e) {
    e.preventDefault();
    clearError();
    var email = (emailInput.value || "").trim();
    var pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!pattern.test(email)) {
      showError(emailValidateMsg);
      emailInput.focus();
      return;
    }
    if (typeof window.showNewsletterModal === "function") {
      window.showNewsletterModal(email);
    }
  });
  emailInput.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      btn.click();
    }
  });
})();
